import React from 'react';
import {RouteChildrenProps} from 'react-router-dom';
import {User} from '@deviceinsight/ng-ui-api-client';
import {fetchMe} from '@deviceinsight/ng-ui-api-client';
import logoPositive from '../assets/rafi-logo-pos.png';
import logoNegative from '../assets/rafi-logo-neg.png';
import './Logo.less';
type Props = RouteChildrenProps & {centered: boolean};

const Logo = (props: Props) => {
	const {centered: isLoginPage, history} = props;

	const goHome = () => {
		if (isLoginPage) return;
		fetchMe().then((user: User) => {
			// @ts-expect-error this function is not part of the ts types but exists
			ngui.getStartPage(user).then((url) => history.push(url));
		});
	};

	const logo = isLoginPage ? logoNegative : logoPositive;
	return (
		<>
			<div className={`di logo clickable${isLoginPage ? ' centered' : ''}`} onClick={goHome}>
				<img src={logo} alt="logo" />
			</div>
		</>
	);
};

export default Logo;
